var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExtraLegSpace = function SvgExtraLegSpace(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0E2336",
    fillRule: "evenodd",
    d: "M4.976 4.841c0-1.418 1.184-2.568 2.644-2.568s2.645 1.15 2.645 2.568S9.082 7.41 7.62 7.41c-1.46 0-2.644-1.15-2.644-2.568M8.76 8.794c.884-.242 1.983.041 2.442 1.124l2.005 4.74q.323-.001.65-.005a37 37 0 0 1 1.7.008c.917.032 1.803.46 2.38 1.157l.002.004 2.673 3.374.004.005c.706.956.348 1.993-.363 2.576-.372.304-.85.497-1.348.496-.502 0-1.008-.199-1.42-.652-.607-.67-1.165-1.405-1.714-2.127q-.362-.48-.723-.942H12.52c-.428 0-.938-.11-1.396-.342-.457-.23-.878-.591-1.1-1.1v-.003L7.522 11.13l-.002-.003c-.23-.578-.168-1.102.09-1.516.253-.408.682-.688 1.151-.817m-4.006.608a.924.924 0 0 0-1.198-.47.88.88 0 0 0-.484 1.163l3.807 8.713c.86 1.967 2.847 3.244 5.047 3.244h2.03a.9.9 0 0 0 .913-.887.9.9 0 0 0-.913-.887h-2.03c-1.467 0-2.792-.852-3.365-2.163z",
    clipRule: "evenodd"
  })));
};
export default SvgExtraLegSpace;